export default __webpack_public_path__ + "static/RTG_PDP_LOGO_STEARNSFOSTER_975x100-18e0ca5c530cebbb4748a50b211e465a.png";